import { useQuery } from '@apollo/client/react';

import getIsServer from '../../../utils/get-is-server';
import getTableOfContentsItems from '../get-table-of-contents-items';
import logger from '../../../logging';
import type { ItemTypename, TableOfContentsData, UseTableOfContentsParams, UseTableOfContentsResult } from './types';

const useTableOfContents = <TData extends TableOfContentsData, TTypename extends ItemTypename | undefined = undefined>({
  query,
  skip,
  slug,
  typename,
}: UseTableOfContentsParams<TData, TTypename>): UseTableOfContentsResult<TData, TTypename> => {
  const { data, error, loading } = useQuery(query, { skip, variables: { identifier: slug } });

  if (!loading && error) {
    logger.getLogger().error('Failed to get table of contents from CMS', { error, isServer: getIsServer(), slug });
  }

  // TODO: Memoising derived `items` (e.g. `useMemo` keyed by `data`/`typename`) would stabilise array identity and reduce unnecessary rerenders in consumers like `Header`, but needs regression testing in case any callers mutate the returned array or rely on identity changes.
  const items = getTableOfContentsItems(data, typename);

  return {
    error,
    items,
    loading,
  };
};

export default useTableOfContents;
